import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";

export interface FastrLinkConfigurationResponse {
  httpStatus: number | undefined;
}

export interface FastrLinkConfigurationRequest {
  practiceId: string;
  fastrLinkId: string;
  fastrLinkHash: string;
}

export const fastrAppLinksApi = createApi({
  reducerPath: "fastrAppLinksApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_YAPI_DOCMGR}api/v1`,
  }),
  endpoints: (builder) => ({
    getFastrLinkConfiguration: builder.query<
      FastrLinkConfigurationResponse,
      FastrLinkConfigurationRequest
    >({
      query: ({ practiceId, fastrLinkId, fastrLinkHash }) => ({
        url: `/fastrapplinks/${fastrLinkId}/${fastrLinkHash}`,
        headers: {
          "X-Yapi-Client-Guid": practiceId,
        },
      }),
      transformResponse: (
        _response: unknown,
        meta: FetchBaseQueryMeta | undefined
      ) => {
        const httpStatus = meta?.response?.status;
        return {
          httpStatus: httpStatus,
        };
      },
    }),
  }),
});

export const { useGetFastrLinkConfigurationQuery } = fastrAppLinksApi;
